export const BOARD_WIDTH = 8
export const BOARD_HEIGHT = 6
export const BOARD_SIDE_HEIGHT = 4 // 0 = bench
export const BOARD_X_START = 672 // 28 * 24
export const BOARD_Y_START = 808

export const CELL_WIDTH = 96
export const CELL_HEIGHT = 96

export const CELL_VISUAL_WIDTH = 75
export const CELL_VISUAL_HEIGHT = 75

export const BERRY_TREE_POSITIONS = [
  [408, 710],
  [360, 710],
  [312, 710]
]
